module.exports = __webpack_public_path__ + "img/collection-diamondJewelrySignet.061a6b7.webp";